export default "__VITE_ASSET__16245ee6__"